import { Link } from "@tanstack/react-router";
import { Icon } from "icons";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { getTrialDaysLeft, getTrialHoursLeft } from "utils";

import { useAuthStore } from "src/auth/AuthContext";

export const TrialEndChip = observer(function TrialEndChip() {
  const authStore = useAuthStore();
  const { t } = useTranslation();

  if (!authStore.isOnTrial) {
    return null;
  }

  const trialEndsAt = authStore.trialEndsAt;

  if (!trialEndsAt) {
    return null;
  }

  const daysLeft = getTrialDaysLeft(trialEndsAt);
  const label =
    daysLeft === 0
      ? t("trialChip.hoursLeft", { count: getTrialHoursLeft(trialEndsAt) })
      : t("trialChip.daysLeft", { count: daysLeft });

  return (
    <Link
      to="/settings/billing"
      className="inline-flex h-9 items-center gap-2 whitespace-nowrap rounded-full bg-gray-50 px-4 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
    >
      <Icon name="tabler-clock" className="h-4 w-4 shrink-0" />
      <span>{label}</span>
    </Link>
  );
});
